<template>
  <svg width="0" height="0" class="hidden">
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="upload"
    >
      <path
        d="M1.5 23A1.5 1.5 0 000 24.5V30a2 2 0 002 2h28a2 2 0 002-2v-5.5a1.5 1.5 0 00-3 0V28a1 1 0 01-1 1H4a1 1 0 01-1-1v-3.5A1.5 1.5 0 001.5 23z"
        fill="#000"
      ></path>
      <path
        d="M14.5 22.688v-18.5L7.9 9.622c-.757.624-1.9.085-1.9-.897 0-.34.15-.665.41-.885L15.351.237a1 1 0 011.296 0L25.59 7.84c.26.22.41.544.41.885 0 .982-1.143 1.521-1.9.897l-6.6-5.434v18.5a1.5 1.5 0 01-3 0z"
        fill="#000"
      ></path>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="show-hide"
    >
      <path
        d="M21 5a5.001 5.001 0 01-3.001 4.585l6.244 6.243a5 5 0 11-1.414 1.414L17 11.415V22.1a5.002 5.002 0 01-1 9.9 5 5 0 01-1-9.9V11.41l-5.83 5.83a5 5 0 11-1.415-1.413l6.243-6.244A5.001 5.001 0 1121 5z"
        fill="#000"
      ></path>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="settings"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M16.574 31.999h-1.178a3.173 3.173 0 01-2.998-2l-.937-2.366a.398.398 0 00-.526-.219l-2.313.994a3.183 3.183 0 01-3.527-.68l-.829-.83a3.202 3.202 0 01-.68-3.531L4.59 21.03a.399.399 0 00-.218-.527l-2.373-.948a3.177 3.177 0 01-1.999-3v-1.15a3.184 3.184 0 011.998-3.001l2.362-.939a.398.398 0 00.22-.527l-.993-2.315a3.194 3.194 0 01.68-3.531l.828-.83a3.186 3.186 0 013.527-.68l2.333 1.003a.397.397 0 00.526-.219l.937-2.365a3.18 3.18 0 012.998-2h1.178a3.174 3.174 0 012.998 2l.937 2.365a.397.397 0 00.526.219l2.333-1.004a3.183 3.183 0 013.526.68l.83.83a3.192 3.192 0 01.68 3.532l-1.003 2.335a.398.398 0 00.219.527l2.362.939a3.177 3.177 0 011.998 3v1.18a3.184 3.184 0 01-1.998 3.002l-2.362.938a.399.399 0 00-.22.527l1.003 2.336a3.204 3.204 0 01-.68 3.53l-.828.83a3.196 3.196 0 01-3.527.681l-2.333-1.003a.398.398 0 00-.526.218l-.937 2.366a3.181 3.181 0 01-3.018 1.97zm-5.987-7.421c.37-.16.79-.149 1.152.029.377.189.768.35 1.169.48a1.4 1.4 0 01.835.8l1.243 3.111a.47.47 0 00.43.29h1.178a.47.47 0 00.39-.29l1.224-3.08c.15-.375.453-.667.834-.8a8.497 8.497 0 001.169-.481 1.377 1.377 0 011.152-.03l3.044 1.31a.48.48 0 00.51-.1l.829-.83a.48.48 0 00.1-.51l-1.308-3.047a1.382 1.382 0 01.029-1.154c.189-.378.349-.769.48-1.17.133-.382.424-.688.798-.84l3.128-1.271a.47.47 0 00.29-.43v-1.16a.47.47 0 00-.29-.41l-3.107-1.245a1.398 1.398 0 01-.8-.836 8.474 8.474 0 00-.48-1.17 1.382 1.382 0 01-.028-1.154l1.308-3.048a.48.48 0 00-.1-.51l-.79-.83a.46.46 0 00-.51-.1l-3.082 1.312c-.37.158-.791.146-1.153-.032a8.446 8.446 0 00-1.169-.48 1.396 1.396 0 01-.835-.8l-1.243-3.11a.47.47 0 00-.43-.29h-1.158a.47.47 0 00-.41.29l-1.243 3.11c-.15.375-.454.667-.835.8a8.37 8.37 0 00-1.169.48 1.378 1.378 0 01-1.152.03l-3.044-1.31a.479.479 0 00-.51.1l-.829.79a.48.48 0 00-.1.51l1.309 3.048c.159.37.148.792-.03 1.153a8.47 8.47 0 00-.48 1.17 1.415 1.415 0 01-.797.843l-3.109 1.278a.47.47 0 00-.29.43v1.18a.47.47 0 00.29.391l3.107 1.244c.375.15.666.455.8.837.13.401.29.792.48 1.17.177.362.188.783.029 1.154l-1.309 3.047a.48.48 0 00.1.51l.83.83a.48.48 0 00.51.1l3.043-1.31zm5.398-2.642a5.93 5.93 0 01-5.483-3.668 5.949 5.949 0 011.287-6.475 5.933 5.933 0 016.467-1.288 5.936 5.936 0 013.663 5.49 5.945 5.945 0 01-1.738 4.201 5.93 5.93 0 01-4.196 1.74zm0-9.142a3.193 3.193 0 00-2.954 1.976 3.205 3.205 0 00.693 3.488 3.196 3.196 0 005.458-2.263 3.205 3.205 0 00-3.197-3.2z"
          fill="#000"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h32v32H0z"></path>
        </clipPath>
      </defs>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="save"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 30a2 2 0 002 2h28a2 2 0 002-2V8.041a2 2 0 00-.853-1.638L22.517.362A2 2 0 0021.37 0H3a3 3 0 00-3 3v27zM10 3a1 1 0 00-1 1v4a1 1 0 001 1h10.5a1.5 1.5 0 010 3H8a2 2 0 01-2-2V4a1 1 0 00-1-1H4a1 1 0 00-1 1v24a1 1 0 001 1h2v-9a2 2 0 012-2h16a2 2 0 012 2v9h2a1 1 0 001-1V10.07a2 2 0 00-.89-1.664l-7.606-5.07A2 2 0 0019.394 3H10zM9 22a1 1 0 011-1h12a1 1 0 011 1v7H9v-7z"
        fill="#000"
      ></path>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="plus"
    >
      <path
        d="M16 0a1.5 1.5 0 00-1.5 1.5v13h-13a1.5 1.5 0 000 3h13v13a1.5 1.5 0 003 0v-13h13a1.5 1.5 0 000-3h-13v-13A1.5 1.5 0 0016 0z"
        fill="#000"
      ></path>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="more"
    >
      <circle cx="4" cy="16" r="4" fill="#000"></circle>
      <circle cx="16" cy="16" r="4" fill="#000"></circle>
      <circle cx="28" cy="16" r="4" fill="#000"></circle>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="minus"
    >
      <path
        d="M1.5 14.5a1.5 1.5 0 000 3h29a1.5 1.5 0 000-3h-29z"
        fill="#000"
      ></path>
    </symbol>
    <symbol      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="login"
    >
      <path
        d="M32 2a2 2 0 00-2-2H1.714C.768 0 0 .768 0 1.714V4.5a1.5 1.5 0 103 0V3h26v26H3v-1.5a1.5 1.5 0 00-3 0V30a2 2 0 002 2h28a2 2 0 002-2V2z"
        fill="#000"
      ></path>
      <path
        d="M1.5 14.5h15.779L12.06 9.282a1.5 1.5 0 112.121-2.121l8.113 8.133a1 1 0 010 1.412l-8.113 8.132a1.5 1.5 0 11-2.121-2.121l5.217-5.217H1.5a1.5 1.5 0 010-3z"
        fill="#000"
      ></path>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="learn"
    >
      <path
        d="M20.457 13.291c.536-.372 1.53-.869 2.565-1.044a.94.94 0 10-.314-1.851c-1.34.226-2.598.848-3.327 1.354a.938.938 0 00-.234 1.308.942.942 0 001.31.233zm-.981 3.747c.67-.408 1.982-1.125 3.232-1.336a.94.94 0 11.314 1.852c-.974.164-2.118.815-2.565 1.087a.942.942 0 01-1.294-.312.938.938 0 01.313-1.29zm-6.858-5.288c-.729-.506-1.985-1.128-3.326-1.354a.94.94 0 10-.314 1.852c1.035.174 2.029.67 2.564 1.043a.942.942 0 001.31-.233.938.938 0 00-.234-1.308zm-3.326 3.952c1.25.21 2.562.928 3.232 1.336.444.27.584.849.313 1.291a.943.943 0 01-1.294.312c-.447-.272-1.591-.923-2.565-1.087a.94.94 0 11.314-1.852z"
        fill="#000"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.091 7.654a59.966 59.966 0 00-3.11-.004V3.94a.94.94 0 00-1.02-.936C23.345 3.305 18.743 4.9 16 7.808 13.258 4.9 8.655 3.305 5.038 3.003a.94.94 0 00-1.02.936V7.75a304.98 304.98 0 00-2.698-.086l-.35-.01a.94.94 0 00-.97.938v17.101a.94.94 0 00.878.937c.551.037 1.157.07 1.805.104 3.753.199 8.908.472 12.948 2.192.422.18.801-.027.738 0 4.04-1.72 9.194-1.993 12.947-2.192.648-.035 1.254-.067 1.806-.104a.94.94 0 00.878-.937v-17.1a.94.94 0 00-.909-.94zM26.1 4.995V21.09c-2.714.606-6.154 1.899-9.158 4.64V9.586c2.06-2.563 5.96-4.108 9.158-4.592zm-20.198 0C9.101 5.479 13 7.024 15.06 9.587v16.141c-3.004-2.74-6.444-4.033-9.158-4.639V4.995zM1.882 24.81V9.56c.674.02 1.395.043 2.137.07v12.226c0 .451.322.84.767.922 2.15.403 4.944 1.276 7.549 3.157-3.333-.745-6.804-.93-9.538-1.075h-.005l-.91-.05zm28.236 0l-.916.05c-2.73.145-6.204.33-9.537 1.075 2.605-1.88 5.4-2.754 7.549-3.157a.94.94 0 00.767-.922V9.529c.866-.02 1.604-.02 2.136-.015v15.295z"
        fill="#000"
      ></path>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="instruction"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-3c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13z"
        fill="#000"
      ></path>
      <path
        d="M17.5 7.5a1.5 1.5 0 00-3 0v11a1.5 1.5 0 003 0v-11zm0 16a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
        fill="#000"
      ></path>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="download"
    >
      <path
        d="M17.5 1.5V20l6.6-5.434a1.163 1.163 0 011.49 1.782l-8.942 7.602a1 1 0 01-1.296 0L6.41 16.348a1.159 1.159 0 01-.409-.885c0-.983 1.143-1.522 1.9-.897L14.5 20V1.5a1.5 1.5 0 013 0z"
        fill="#000"
      ></path>
      <path
        d="M1.5 23A1.5 1.5 0 000 24.5V30a2 2 0 002 2h28a2 2 0 002-2v-5.5a1.5 1.5 0 00-3 0V28a1 1 0 01-1 1H4a1 1 0 01-1-1v-3.5A1.5 1.5 0 001.5 23z"
        fill="#000"
      ></path>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="copy"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 6a1 1 0 011-1h18a1 1 0 011 1v25a1 1 0 01-1 1H1a1 1 0 01-1-1V6zm3 2.5a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v20a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-20z"
        fill="#000"
      ></path>
      <path
        d="M13 0h18a1 1 0 011 1v25a1 1 0 01-1 1H20v-3h8.5a.5.5 0 00.5-.5v-20a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5V5h-3V1a1 1 0 011-1z"
        fill="#000"
      ></path>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="close"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M.404.404a1.379 1.379 0 000 1.95L14.05 16 .404 29.647a1.378 1.378 0 101.95 1.95L16 17.948l13.647 13.647a1.378 1.378 0 101.95-1.95L17.948 16 31.596 2.353a1.378 1.378 0 10-1.95-1.95L16 14.052 2.353.403a1.379 1.379 0 00-1.95 0z"
          fill="#000"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h32v32H0z"></path>
        </clipPath>
      </defs>
    </symbol>
    <symbol      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="check"
    >
      <path
        d="M31.547 8.671a1.563 1.563 0 000-2.2 1.59 1.59 0 00-2.259 0L13.412 22.515 2.712 11.7a1.591 1.591 0 00-2.259 0 1.562 1.562 0 000 2.201L13.413 27 31.546 8.671z"
        fill="#000"
      ></path>
    </symbol>
    <symbol      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      id="shape"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.488 0.309237L15.6881 3.51003C16.104 3.92922 16.104 4.6055 15.6881 5.02469L6.09118 14.6242C5.95132 14.759 5.77849 14.8546 5.59002 14.9014L1.32475 15.968C1.24105 15.9891 1.15507 15.9999 1.06874 16C0.78545 16.0009 0.513296 15.8897 0.311572 15.6908C0.0448202 15.4268 -0.0608317 15.0404 0.0344204 14.6774L1.10074 10.4112C1.14316 10.221 1.23936 10.047 1.37789 9.90991L10.9736 0.309237C11.3942 -0.103079 12.0673 -0.103079 12.488 0.309237ZM1.49554 14.5059L5.20585 13.3227L14.3497 4.17688L11.866 1.69261L2.72212 10.8384L1.49554 14.5059Z" fill="#000000"/>
    </symbol>
    <symbol
      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="basket"
    >
      <path
        d="M11 12.5a1.5 1.5 0 013 0v13a1.5 1.5 0 01-3 0v-13zm8.5-1.5a1.5 1.5 0 00-1.5 1.5v13a1.5 1.5 0 003 0v-13a1.5 1.5 0 00-1.5-1.5z"
        fill="#000"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 4a4 4 0 014-4h10a4 4 0 014 4v2h4.5a1.5 1.5 0 010 3H28v19c0 2.5-1.5 4-4 4H8c-2.5 0-4-1.5-4-4V9H2.5a1.5 1.5 0 110-3H7V4zm16 25c1.5 0 2-.5 2-2V9H7v18c0 1.5.5 2 2 2h14zM10 6V5a2 2 0 012-2h8a2 2 0 012 2v1H10z"
        fill="#000"
      ></path>
    </symbol>
    <symbol      
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 10"
      id="accordion-arrow"
    >
      <path d="M15.5 1.08496L8.5 8.11472L1.5 1.08496" stroke="#56565A" stroke-width="1.5" stroke-linecap="round"/>
    </symbol>
  </svg>
</template>
<style lang="scss">
path, circle {
  fill: inherit
}
</style>